<template>
  <v-dialog v-model="dialog" width="500">
    <template v-slot:activator="{ on }">
      <v-btn medium v-on="on" color="primary"> <v-icon>add</v-icon>Thêm </v-btn>
    </template>
    <v-card>
      <v-toolbar dense class="elevation-0" color="#FFB300" dark>
        <v-toolbar-title>Tạo Mới Môn Học</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon>
          <v-icon @click="cancel">close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-container>
        <v-form ref="form" v-model="valid" :lazy-validation="true">
          <v-text-field
            :rules="[$rules.required]"
            v-model="title"
            outlined
            dense
            label="Tên Khóa Học"
            placeholder="Nhập tên Khóa Học"
          ></v-text-field>
          <v-text-field
            :rules="[$rules.required]"
            v-model="code"
            outlined
            dense
            label="Mã Khóa Học"
            placeholder="Nhập mã khóa học"
          ></v-text-field>
          <v-text-field
            :rules="[$rules.required]"
            v-model="description"
            dense
            outlined
            label="Mô Tả Khóa Học"
            placeholder="Nhập mô tả mã khóa học"
          ></v-text-field>
          <v-select
            :items="statusList"
            label="Trạng Thái"
            item-value="value"
            item-text="text"
            v-model="status"
            dense
            outlined
          ></v-select>
          <v-text-field
            v-if="major"
            :rules="[$rules.required]"
            :value="major.title"
            dense
            outlined
            label="Chuyên ngành"
            disabled
          ></v-text-field>
        </v-form>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" smalls @click="save" depressed>Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  data() {
    return {
      valid: true,
      dialog: false,
      title: '',
      description: '',
      code: '',
      statusList: [
        { text: 'Khóa', value: 'private' },
        { text: 'Mở', value: 'public' }
      ],
      status: 'public',
    }
  },
  props: {
    major: Object
    // selected: { type: Array, default: () => [] }
  },
  computed: {
    ...mapState('app', ['roles', 'department'])
  },
  methods: {
    ...mapActions('course', ['createCourse', 'fetchCourses']),
    save() {
      const result = this.$refs.form.validate()
      this.valid = result
      if (!result) {
        this.$alert.error('Lỗi Form! Vui lòng kiểm tra lại')
        return
      }
      this.createCourse({
        data: {
          title: this.title,
          description: this.description,
          code: this.code,
          status: this.status,
          department: this.department.id,
          factor: 1,
          mark: [
            // {
            //   title: 'Kiểm Tra số 1',
            //   multiplier: 1,
            //   minimum: 0,
            //   code: 1
            // },
            // {
            //   title: 'Kiểm Tra số 2',
            //   multiplier: 1,
            //   minimum: 0,
            //   code: 1
            // }
          ],
          ...(this.major && {
            majors: [this.major._id]
          })
        }
      })
      this.fetchCourses()
      this.dialog = false
      this.$alert.success('Tạo khóa học thành công')
      this.$refs.form.reset()
    },
    cancel() {
      this.dialog = false
      this.reset()
    },
    reset() {
      this.title = ''
      this.code = ''
      this.description = ''
      this.status = 'public'
    }
  }
}
</script>
